import React from 'react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';

const faqs = [
  {
    question: 'What is the MHDF Momentum Project?',
    answer: 'MHDF Momentum is a 365-day mental wellness companion program offering two pathways: Clinical (therapist-prescribed) or Self-Guided (independent). Both provide daily structure through Mind, Move, and Journal practices, with optional faith integration.'
  },
  {
    question: "What's the difference between Clinical and Self-Guided pathways?",
    answer: 'Clinical pathway is for clients working with a therapist who prescribes Momentum as homework. Your clinician can monitor progress with your consent. Self-Guided is for independent practice—same content, full autonomy, no therapist required.'
  },
  {
    question: 'Is the Faith pillar required?',
    answer: 'No. Faith integration is entirely optional and available in either pathway. The three core daily practices (Mind, Move, Journal) work with or without faith content. You can enable or disable it anytime.'
  },
  {
    question: 'Can I switch from Self-Guided to Clinical later?',
    answer: 'Yes. If you start self-guided and later begin therapy, your therapist can link to your account with a referral code. Your progress and history remain intact.'
  },
  {
    question: 'How much time does it take each day?',
    answer: 'Most days are designed to take 30–45 minutes total for the three core practices. If you add the optional Faith pillar, budget an extra 10–15 minutes.'
  },
  {
    question: 'Can clinicians monitor progress?',
    answer: 'Yes, but only in the Clinical pathway and only with explicit client consent. Clinicians can view engagement, streaks, and trends to support treatment planning. Self-guided users maintain full privacy.'
  },
  {
    question: 'Is my data secure?',
    answer: 'Yes. Sensitive entries are encrypted, and access is protected by role-based controls and HIPAA-aligned practices. Your journal is private in both pathways.'
  },
  {
    question: 'What happens after Day 365?',
    answer: 'Graduation includes an optional certificate and the ability to continue for another 365-day cycle, or you can export your Personal Wellness Playbook and continue independently.'
  }
];

const FaqPage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">FAQ</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">Questions, answered.</h1>
            <p className="text-lg md:text-xl text-text-muted">
              Everything you need to know about how MHDF Momentum supports mental wellness between sessions.
            </p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Getting Started"
            title="Common questions"
            subtitle="If you have a question that isn’t answered here, reach out to our team."
            alignment="left"
          />

          <div className="mt-10 grid gap-6">
            {faqs.map((faq) => (
              <Card key={faq.question} variant="feature">
                <h3 className="text-lg font-semibold text-neutral-900">{faq.question}</h3>
                <p className="mt-2 text-text-muted">{faq.answer}</p>
              </Card>
            ))}
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default FaqPage;
